import Vue from 'vue'
import VueRouter from 'vue-router'
import AsyncComputed from 'vue-async-computed'
import VueHotkey from 'v-hotkey'
import Meta from 'vue-meta'
import vSelect from 'vue-select'
import Multiselect from 'vue-multiselect'
import DatetimePicker from 'vue-bootstrap-datetimepicker'
import App from './pages/app.vue'
import VeeValidate, { Validator } from 'vee-validate'
import ru from 'vee-validate/dist/locale/ru'

import './element-ui'
import './components'
import './directives'
import './filters'
import './font-awesome'

Vue.use(VueRouter)
Vue.use(AsyncComputed)
Vue.use(VueHotkey)
Vue.use(Meta)
Vue.use(VeeValidate, {events: 'blur'})
Validator.localize('ru', ru)
Vue.component('v-select', vSelect)
Vue.component('multiselect', Multiselect)
Vue.component('datetime-picker', DatetimePicker)

Vue.config.productionTip = false

export default new Vue(App)



// WEBPACK FOOTER //
// ./resources/assets/js/root.js